<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card
          color="#ac8a2e"
          inline
          title="Pedidos"
        >
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="solicitante"
                      rules="required|max:45"
                    >
                      <v-text-field
                        v-model="dataForm.solicitante"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Solicitante"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="contacto"
                      rules="max:45"
                    >
                      <v-text-field
                        v-model="dataForm.solicitante_contacto"
                        color="#ac8a2e"
                        :error-messages="errors"
                        label="Contacto"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="club"
                    >
                      <v-autocomplete v-model="dataForm.club_id" :disabled="dataForm.liga_id != null" color="gold" :error-messages="errors" label="Club" item-value="id" item-text="descripcion" :items="clubes" clearable>
                        <template v-slot:append-outer>
                          <v-btn elevation="1" color="success" fab x-small @click="mostrarClubForm = true">
                            <v-icon>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="Liga"
                    >
                      <v-select v-model="dataForm.liga_id" :disabled="dataForm.club_id != null" color="gold" :error-messages="errors" label="Liga" item-value="id" item-text="descripcion" :items="ligas" clearable>
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="290px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                          <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="dataForm.fecha"
                        color="gold"
                        landscape
                        scrollable
                        locale="es-419"
                        no-title
                        @input="menu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="detalle"
                      rules="required|max:500"
                    >
                      <v-textarea
                        v-model="dataForm.detalle_solicitud"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Detalle"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-row
                      justify="space-between"
                    >
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
    <clubs-form :show="mostrarClubForm" @close="mostrarClubForm = false" @close-dialog="closeDialog" />
  </v-container>
</template>

<script>
  import ClubsForm from '../altas/ClubsForm.vue'
  export default {
    components: {
      ClubsForm,
    },
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      mostrarClubForm: false,
      tittle: 'Nuevo',
      menu: false,
      clubes: [],
      ligas: [],
      dataForm: {
        id: '',
        fecha: '',
        solicitante: '',
        solicitante_contacto: '',
        club_id: null,
        liga_id: null,
        detalle_solicitud: '',
        fecha_cierre: '',
        user_id: 0,
        club: {
          id: '',
          descripcion: '',
        },
      },
    }),
    computed: {
    },
    created () {
      this.setTittle()
      this.getClubes()
      this.getLigas()
      if (this.mode !== 'new') {
        this.getPedido()
      }
    },
    methods: {

      setTittle: function () {
        if (this.mode === 'new') {
          this.tittle = 'Nuevo pedido'
        }
        if (this.mode === 'edit') {
          this.tittle = 'Editar pedido'
        }
      },

      getPedido: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pedido_mercado/' + this.id }).then(response => { this.dataForm = response })
      },

      getClubes: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/club_get' }).then(response => { this.clubes = response })
      },

      getLigas: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/liga_get' }).then(response => { this.ligas = response })
      },

      validateForm (scope) {
        this.savePedido()
      },
      closeDialog (club) {
        this.getClubes()
        this.dataForm.club_id = club.id
      },

      savePedido: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/pedido_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de pedido exitosa'] })
          this.$router.push({ name: 'Pedidos de mercado' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
        /* const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/pedido_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de pedido exitosa'] })
          this.$router.push({ name: 'Pedidos de mercado' })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        }) */
      },
    },
  }
</script>
